/**
 * Keeps the app inside the part of the screen that is actually visible.
 *
 * On phones the on-screen keyboard covers the bottom of the page. Chrome on Android shrinks the
 * page for it (interactive-widget=resizes-content in index.html), but iOS Safari instead scrolls
 * the whole page up, pushing the header out of view. The visual viewport says what is visible:
 * the app is sized to its height and moved to its top (CSS variables used on #root).
 */
export function trackVisualViewport(): void {
  const vv = window.visualViewport;
  if (!vv) return;
  const root = document.documentElement;
  let frame = 0;
  const update = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      root.style.setProperty("--app-height", `${Math.round(vv.height)}px`);
      root.style.setProperty("--app-top", `${Math.round(vv.offsetTop)}px`);
      // With the keyboard up, the bottom safe area (iPhone home indicator) is covered by it.
      root.classList.toggle("keyboard-open", window.innerHeight - vv.height > 120);
    });
  };
  vv.addEventListener("resize", update);
  vv.addEventListener("scroll", update);
  update();
}

/** Focusing a text field on a touch screen opens the keyboard, so only autofocus with a mouse. */
export function canAutoFocus(): boolean {
  return window.matchMedia?.("(pointer: fine)").matches ?? true;
}
